// creates a temporary link to download the file
export const createAndClickDownloadUrl = (href: string, title: string) => {
    const link = document.createElement('a');
    link.href = href;
    link.download = title;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
